import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
import { Head } from "@cinch-nx/landing-ui-shared";
import HelpAndSupport from "./components/help-and-support/help-and-support";
export const SupportPage = ({ story , preview , generatedAt  })=>{
    const typedStory = story;
    const { content  } = useStoryblokState({
        story: typedStory,
        enableBridge: preview
    });
    const SEO = Array.isArray(content === null || content === void 0 ? void 0 : content.SEO) && content.SEO[0];
    const FAQs = content.faqs;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: "Support - cinch",
                fallbackDescription: "Whether you have a specific query (or a more general one), we’re here to help. Check out the links at the bottom of the page, head to our FAQs, or get in touch with us the way that’s easiest for you."
            }),
            /*#__PURE__*/ _jsx(HelpAndSupport, {
                faqs: FAQs
            })
        ]
    });
};
